import { render, staticRenderFns } from "./outros.vue?vue&type=template&id=4379b312&"
import script from "./outros.vue?vue&type=script&lang=js&"
export * from "./outros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports